module.exports = __webpack_public_path__ + "img/1e77b26.png";